import { bindActionCreators } from "redux";
import useCustomDispatch from "./useCustomDispatch";
import allActionsHandlers from "@actions/allActionsHandlers";
import taskManagementActionsHandlers from "@actions/taskManagement/taskManagementActionsHandlers";
import inventoryActionsHandlers from "@actions/inventory/inventoryActionsHandlers";
import procurementsActionsHandlers from "@actions/procurements/procurementsActionsHandlers";
import HRMActionsHandlers from "@actions/HRM/HRMActionsHandlers";

const useActionCreator = () => {
  const dispatch = useCustomDispatch();
  const allActionCreator = bindActionCreators(allActionsHandlers, dispatch);

  const inventoryActionCreator = bindActionCreators(
    inventoryActionsHandlers,
    dispatch,
  );

  const procurementActionCreator = bindActionCreators(
    procurementsActionsHandlers,
    dispatch,
  );

  const taskManagementActionCreator = bindActionCreators(
    taskManagementActionsHandlers,
    dispatch,
  );

  const HRMActionCreator = bindActionCreators(HRMActionsHandlers, dispatch);

  return {
    ...allActionCreator,
    HRMActionsHandlers: HRMActionCreator,
    inventoryActionsHandlers: inventoryActionCreator,
    procurementsActionsHandlers: procurementActionCreator,
    taskManagementActionsHandlers: taskManagementActionCreator,
  };
};

export default useActionCreator;
